import React from "react";

interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
  className?: string; // Optional className prop for additional styling
}

function RadioButton(props: RadioButtonProps) {
  const { label, checked, onCheck, className, ...rest } = props;

  return (
    <label className={`flex items-center gap-2 cursor-pointer ${className}`}>
      <input
        {...rest}
        type="radio"
        checked={checked}
        className="peer sr-only focus:not-sr-only focus:absolute focus:w-[20px] focus:h-[20px] focus:opacity-0"
        onChange={(e) => onCheck(e.target.checked)}
        aria-label={checked ? `${label} selected` : `${label}`}
      />
      <div
        className={`w-[20px] h-[20px] rounded-full border-[1.5px] border-border-token-neutral-strong bg-bg-brand-secondary-default flex items-center justify-center transition-colors peer-checked:bg-bg-brand-primary-default peer-checked:border-bg-brand-primary-default peer-hover:bg-bg-brand-secondary-hover peer-focus:ring-2 peer-focus:ring-focusRing-default peer-focus:ring-offset-2 peer-focus:ring-offset-surface-primary`}
        tabIndex={-1}
        aria-hidden="true"
      >
        {checked && (
          <div className="w-[8px] h-[8px] rounded-full bg-fg-neutral-on-filled" />
        )}
      </div>
      <span
        className="text-fg-neutral-strong label-m-medium"
        aria-hidden="true"
      >
        {label}
      </span>
    </label>
  );
}

export default RadioButton;
